import { damageControlStrict } from "@/api/damageControl";
import damageControlAccessMixin from "@/mixins/damageControlAccessMixin";
import roleMixin from "@/mixins/roleMixin";

// Shared guard for every submit surface, including direct method calls. A result
// belongs to one open dialog, booking, car and access state; never reuse an old one.
export default {
  mixins: [roleMixin, damageControlAccessMixin],
  data() { return { damageControlState: null }; },
  computed: {
    damageControlCompany() {
      const getters = this.$store && this.$store.getters;
      if (getters && getters.getCompany) return damageControlAccessMixin.computed.damageControlCompany.call(this);
      return this.company;
    },
    damageControlEnabled() { return this.damageControlAvailable; },
    damageControlContext() {
      return JSON.stringify([this.damageControlCompany && this.damageControlCompany.id, this.booking.id, this.booking.car_id,
        this.value, this.damageControlEnabled, damageControlStrict(this.damageControlCompany)]);
    },
    damageControlBlocked() {
      if (!this.damageControlEnabled) return false;
      if (!damageControlStrict(this.damageControlCompany)) return false;
      if (!this.damageControlState || this.damageControlState.context !== this.damageControlContext) return true;
      return this.damageControlState.blocked;
    },
    damageControlReasons() {
      if (!this.damageControlBlocked) return [];
      if (!this.damageControlState || this.damageControlState.context !== this.damageControlContext) return [{ reason: "damage_control.strict.checking" }];
      return this.damageControlState.reasons;
    },
    // Причины одного вида — одной строкой: до трёх зон и «и ещё N». Иначе на телефоне 14 строк «нужен кадр».
    damageControlReasonLines() {
      const lines = [];
      this.damageControlReasons.forEach(({ reason, title }) => {
        let line = lines.find(item => item.reason === reason);
        if (!line) lines.push(line = { reason, titles: [] });
        if (title) line.titles.push(title);
      });
      return lines.map(({ reason, titles }) => ({ reason, titles: titles.slice(0, 3), more: Math.max(0, titles.length - 3) }));
    },
  },
  watch: { value() { this.damageControlState = null; } },
  methods: {
    onDamageControlBlocking(blocked, reasons) {
      this.damageControlState = { context: this.damageControlContext, blocked, reasons };
    },
  },
};
